import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CustomsData } from '../../models/customs-data';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class ScrappinProxyService {
  // private readonly baseUrl = 'https://0476-179-60-175-123.ngrok-free.app' + '/api/scrapping';

  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.orderApi + '/api/v1/scraping';

  public getScrappin(url: string): Observable<ApiResponse<CustomsData>> {
    const pararms = new HttpParams().set('url', url);
    return this.httpClient.get<ApiResponse<CustomsData>>(this.baseUrl, { params: pararms });
  }
}
